import { FC, memo } from "react";

import { useAppSelector } from "@/hooks/redux";
import ReportTable from "@/components/reportTable/ReportTable";

interface StandStreamTableProps {
  isAutoScroll: boolean;
}

const StandStreamTable: FC<StandStreamTableProps> = ({ isAutoScroll }) => {
  const { examinationData, currentExaminationData } = useAppSelector(
    (state) => state.currentDataReducer
  );

  const data = currentExaminationData
    ? [...examinationData, currentExaminationData]
    : examinationData;

  return <ReportTable data={data || []} isAutoScroll={isAutoScroll} />;
};

export default memo(StandStreamTable);
